import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const schoolStudentList = createAsyncThunk(
  'school/student-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getEducationDegrees = createAsyncThunk(
  'school/get-education-degrees',
  async (_, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/get-education-degrees`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getClassRooms = createAsyncThunk(
  'school/get-class-rooms',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/get-class-rooms/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const schoolStudentStore = createAsyncThunk(
  'school/student-store',
  async (studentData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-student/store`, studentData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolStudentEdit = createAsyncThunk(
  'school/student-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const schoolStudentView = createAsyncThunk(
  'school/student-view',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/view/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getStudentRelatives = createAsyncThunk(
  'school/get-student-relatives',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/get-student-relatives/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const studentRelativeStore = createAsyncThunk(
  'school/student-relative-store',
  async (stdRelativeData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(
        `${api}school-student/store-student-relative`,
        stdRelativeData
      )
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const studentRelativeEdit = createAsyncThunk(
  'school/student-relative-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/edit-student-relative/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const studentRelativeDelete = createAsyncThunk(
  'school/student-relative-delete',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-student/delete-student-relative/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

type SchoolStudentState = {
  errors: any
}

const initialState: SchoolStudentState = {
  errors: '',
}

export const schoolStudentSlice = createSlice({
  name: 'school-student',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(schoolStudentStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(studentRelativeStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = schoolStudentSlice.actions
export default schoolStudentSlice.reducer
